// extracted by mini-css-extract-plugin
export default {"cardMain":"HeaderCard_cardMain__wU-iI"};